(function () {
  'use strict';

  // ─── Registry: normalised URL → { section, title } ───────────────────────
  var registry = {};
  var currentUrl = normalise(location.href);

  function normalise(url) {
    return url.split('?')[0].replace(/\/$/, '');
  }

  // ─── Find the main product section ───────────────────────────────────────
  var curSection = document.querySelector('section[id^="MainProduct-"]');
  if (!curSection) return;

  // Wrap everything in a relative container so absolute siblings stack on top
  var container = document.createElement('div');
  container.className = 'sibling-container';
  container.style.cssText = 'position:relative;';
  curSection.parentNode.insertBefore(container, curSection);
  container.appendChild(curSection);

  registry[currentUrl] = { section: curSection, title: document.title };

  // ─── CSS states ───────────────────────────────────────────────────────────
  var HIDDEN_CSS = [
    'position:absolute',
    'top:0', 'left:0',
    'width:100%',
    'visibility:hidden',
    'pointer-events:none',
    'z-index:-1',
  ].join(';');

  var VISIBLE_CSS = 'position:relative;';

  // ─── Inject a sibling section into the DOM (hidden) ──────────────────────
  function inject(originalUrl, html) {
    var url = normalise(originalUrl);
    var doc  = new DOMParser().parseFromString(html, 'text/html');
    var sect = doc.querySelector('section[id^="MainProduct-"]');
    if (!sect) { delete registry[url]; return; }

    // Rename all IDs to avoid collisions with the live page
    var sid = sect.dataset.section;
    if (sid) {
      sect.innerHTML   = sect.innerHTML.replaceAll(sid, 'sb-' + sid);
      sect.id          = 'sb-' + sect.id;
      sect.dataset.section = 'sb-' + sid;
    }

    // Place off-screen but still in layout so Swiper can measure width
    sect.style.cssText = HIDDEN_CSS;
    container.appendChild(sect);

    // Force-load images (browser skips lazy images in hidden elements)
    sect.querySelectorAll('img').forEach(function (img) {
      img.removeAttribute('loading');
      if (img.dataset.src   && !img.getAttribute('src'))    img.src    = img.dataset.src;
      if (img.dataset.srcset && !img.getAttribute('srcset')) img.srcset = img.dataset.srcset;
    });

    // Re-execute inline scripts so custom elements (variant-selects etc.) boot
    sect.querySelectorAll('script').forEach(function (old) {
      var fresh = document.createElement('script');
      Array.from(old.attributes).forEach(function (a) { fresh.setAttribute(a.name, a.value); });
      fresh.textContent = old.textContent;
      old.parentNode.replaceChild(fresh, old);
    });

    // Init the image slider scoped to this section only.
    // quickAddsliderInit accepts a container and won't touch other sections.
    if (typeof quickAddsliderInit === 'function') {
      setTimeout(function () { quickAddsliderInit(true, sect); }, 200);
    }

    registry[url] = { section: sect, title: doc.title };
  }

  // ─── Instantly show a section ─────────────────────────────────────────────
  function show(rawUrl, pushState) {
    var url   = normalise(rawUrl);
    var entry = registry[url];
    if (!entry || !entry.section) {
      // Not loaded yet — fall back to regular navigation
      location.href = rawUrl;
      return;
    }

    var prev = registry[currentUrl];
    if (prev && prev.section !== entry.section) {
      prev.section.style.cssText = HIDDEN_CSS;
    }

    // This is the only operation on click — a style string swap
    entry.section.style.cssText = VISIBLE_CSS;

    currentUrl = url;
    document.title = entry.title;
    if (pushState !== false) {
      history.pushState({ siblingUrl: rawUrl }, entry.title, rawUrl);
    }
  }

  // ─── Fetch all sibling pages immediately on load ──────────────────────────
  function warmUp() {
    document.querySelectorAll('.linked-products a[href]').forEach(function (link) {
      var url = normalise(link.href);
      if (url === currentUrl || registry.hasOwnProperty(url)) return;

      // Reserve the slot to prevent double-fetch
      registry[url] = null;

      fetch(link.href, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) { inject(link.href, html); })
        .catch(function () { delete registry[url]; });
    });
  }

  // ─── Event listeners (registered once, survive content swaps) ────────────
  if (!window.__siblingListeners) {
    window.__siblingListeners = true;

    document.addEventListener('click', function (e) {
      var link = e.target.closest('.linked-products a[href]');
      if (!link) return;
      e.preventDefault();
      var url = normalise(link.href);
      if (url === currentUrl) return;
      show(link.href);
    });

    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.siblingUrl) show(e.state.siblingUrl, false);
    });
  }

  warmUp();
})();
